import { render, staticRenderFns } from "./SubcategoryPage.vue?vue&type=template&id=3d55cc0a"
import script from "./SubcategoryPage.vue?vue&type=script&lang=js"
export * from "./SubcategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports